export const ACCEPTED_FILE_TYPES = "image/jpg,image/jpeg,image/png";
